import { LazyWrapper } from '../../../common';

const CalcDialog = LazyWrapper({
  importFn: () => import('./CalcDialog'),
});
export default CalcDialog;
